<div class="p-mt-5">
  <ng-container *ngIf="jeLicniNacinOtpreme && nacinOtpreme != null" [ngTemplateOutlet]="licniNacin">
  </ng-container>

  <ng-container *ngIf="!jeLicniNacinOtpreme && nacinOtpreme != null" [ngTemplateOutlet]="prevoz">
  </ng-container>

  <ng-template #licniNacin>
    <kodit-card-container>
      <div card-body class="p-mt-5">
        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-text-input-field
            formCtrlId="ime"
            formCtrlLabel="Ime"
            [formCtrl]="
              otpremnicaFormGroup.controls.licniNacinOtpreme?.get('ime')
            "
            class="flex-1"
          ></kodit-text-input-field>

          <kodit-text-input-field
            formCtrlId="prezime"
            formCtrlLabel="Prezime"
            [formCtrl]="
              otpremnicaFormGroup.controls.licniNacinOtpreme?.get('prezime')
            "
            class="flex-1"
          ></kodit-text-input-field>
        </div>
        <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
          <kodit-text-input-field
            formCtrlId="broj-licne-karte"
            formCtrlLabel="Broj lične karte"
            [formCtrl]="
              otpremnicaFormGroup.controls.licniNacinOtpreme?.get(
                'brojLicneKarte'
              )
            "
            class="flex-50"
          ></kodit-text-input-field>
        </div>
      </div>
    </kodit-card-container>
  </ng-template>

  <ng-template #prevoz>
    <div
      *ngFor="let faza of fazeVoznje.controls; let i = index"
      [formGroup]="faza"
    >
      <div class="p-mt-3">
        <kodit-card-container>
          <div card-body>
            <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid">
              <kodit-text-input-field
                formCtrlId="mestoUtovara"
                formCtrlLabel="Mesto utovara"
                [formCtrl]="faza.get('mestoUtovara')"
                class="flex-1"
              ></kodit-text-input-field>

              <kodit-text-input-field
                formCtrlId="mestoIsporuke"
                formCtrlLabel="Mesto isporuke"
                [formCtrl]="faza.get('mestoIsporuke')"
                class="flex-1"
              ></kodit-text-input-field>
            </div>
            <div class="p-d-flex p-flex-column p-flex-md-row gap-12 p-fluid p-mt-5">
              <div class="flex-50 p-d-flex p-flex-column gap-12">
                <h5>PREVOZNIK</h5>
                <kodit-stranka-prevoznik-faze
                  [otpremnicaFormGroup]="otpremnicaFormGroup"
                  [index]="i"
                  [nacinOtpreme]="nacinOtpreme">
                </kodit-stranka-prevoznik-faze>
              </div>

              <div class="flex-50 p-d-flex p-flex-column gap-12">
                <h5>VOZAČ FAZE</h5>
                <div class="p-d-flex p-flex-column p-flex-md-row gap-12">
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-ime"
                    formCtrlLabel="Ime"
                    [formCtrl]="faza.get('vozacDto.ime')"
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-telefon"
                    formCtrlLabel="Email"
                    [formCtrl]="
                      faza.get('vozacDto.email')
                    "
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                </div>
                <div class="p-d-flex gap-12 mt-2">
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-email"
                    formCtrlLabel="Prezime"
                    [formCtrl]="faza.get('vozacDto.prezime')"
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-email"
                    formCtrlLabel="Telefon"
                    [formCtrl]="faza.get('vozacDto.telefon')"
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                </div>
                <div class="p-d-flex gap-12 mt-2">
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-email"
                    formCtrlLabel="Registarski broj vozila"
                    [formCtrl]="faza.get('vozacDto.registarskiBrojVozila')"
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                  <kodit-text-input-field
                    formCtrlId="posiljalac-kontakt-email"
                    formCtrlLabel="Broj vozačke dozvole"
                    [formCtrl]="faza.get('vozacDto.brojVozackeDozvole')"
                    class="flex-50"
                  >
                  </kodit-text-input-field>
                </div>
              </div>
            </div>
          </div>
          <div card-body class="p-mt-5" *ngIf="fazeVoznje.length > 1">
            <kodit-button
              type="button"
              btnIcon="far fa-trash-alt"
              btnLabel="Obrisi fazu voznje"
              (click)="delete(i)"
            ></kodit-button>
          </div>
        </kodit-card-container>
      </div>
    </div>
    <div class="p-mt-5">
      <kodit-button
        type="button"
        btnIcon="fa-solid fa-plus"
        btnLabel="Dodaj novu fazu vožnje"
        (click)="dodajFazu()"
      ></kodit-button>
    </div>
  </ng-template>
</div>
